const MUTATION_TYPE = {
  setParticipants: 'setParticipants',
  setStudentsProgress: 'setStudentsProgress',
  setTestProgress: 'setTestProgress',
  setReportId: 'setReportId',
  setTestReviewMode: 'setTestReviewMode',
  setSolvedByStudent: 'setSolvedByStudent',
  setSimulatorMarks: 'setSimulatorMarks',
  setGroupTrainingSettings: 'setGroupTrainingSettings',
  setGroupTrainingStudents: 'setGroupTrainingStudents',
  setGroupTrainingTeams: 'setGroupTrainingTeams',
  setGroupTrainingMode: 'setGroupTrainingMode',
  updateTeams: 'updateTeams',
  addStudents: 'addStudents',
  removeStudents: 'removeStudents',
  updateStudent: 'updateStudent',
  setCurrentPage: 'setCurrentPage',
  setCurrentPageSize: 'setCurrentPageSize',
  setTotal: 'setTotal',
  setPages: 'setPages'
}

const ACTION_TYPE = {
  fetchCourseStudentsProgress: 'fetchCourseStudentsProgress',
  fetchTestStudentsProgress: 'fetchTestStudentsProgress',
  fetchSimulatorMarks: 'fetchSimulatorMarks'
}

const GETTER_TYPE = {
  getParticipants: 'getParticipants',
  getStudentsProgress: 'getStudentsProgress',
  getTestProgress: 'getTestProgress',
  getReportId: 'getReportId',
  getTestReviewMode: 'getTestReviewMode',
  getSolvedByStudent: 'getSolvedByStudent',
  getSimulatorMarks: 'getSimulatorMarks',
  getGroupTrainingSettings: 'getGroupTrainingSettings',
  getGroupTrainingStudents: 'getGroupTrainingStudents',
  getGroupTrainingMode: 'getGroupTrainingMode',
  getGroupTrainingTeams: 'getGroupTrainingTeams',
  getTotal: 'getTotal',
  getPages: 'getPages',
  getCurrentPage: 'getCurrentPage',
  getPaginationPageSize: 'getPaginationPageSize'
}

export {
  MUTATION_TYPE,
  ACTION_TYPE,
  GETTER_TYPE
}
